import type { EditPlayerFormValues, PlayerCategory } from './types'

export const CATEGORIES: ReadonlyArray<PlayerCategory> = [
  { key: 'personal', label: 'Personal Information', index: 1 },
  { key: 'address', label: 'Address', index: 2 },
  { key: 'emergencyContact', label: 'Emergency Contact', index: 3 },
  { key: 'socialProfiles', label: 'Social Profiles', index: 4 },
  { key: 'membership', label: 'Membership', index: 5 },
]

/**
 * Sentinel form value for the "Unspecified" gender option. It must be a
 * non-empty string so the select round-trips it DISTINCTLY from a cleared
 * dropdown (''). The payload transforms convert this sentinel to an explicit
 * `gender_id: null` when the user changes TO it; it's also the default the form
 * seeds when the player has no gender set, so an untouched form omits it (diff).
 */
export const GENDER_UNSPECIFIED = 'unspecified'

/**
 * Gender select options. Values are gender_type ids (sent as gender_id). "Non
 * Binary" is relabeled from the DB's "Coed"; the stored id is unchanged.
 * "Unspecified" uses a sentinel value (not '') so it's distinguishable from a
 * cleared field and submits gender_id: null. It is also the default option when
 * no gender is set.
 */
export const GENDER_OPTIONS: ReadonlyArray<{
  label: string
  value: string
}> = [
  { label: 'Male', value: '1' },
  { label: 'Female', value: '2' },
  { label: 'Non Binary', value: '3' },
  { label: 'Unspecified', value: GENDER_UNSPECIFIED },
]

export const initialPlayerValues: EditPlayerFormValues = {
  firstName: '',
  lastName: '',
  birthDate: '',
  genderId: GENDER_UNSPECIFIED,
  heightFt: '',
  heightIn: '',
  weight: '',
  imageUrl: '',
  imageData: '',
  imageDeleted: false,
  phoneNumber: '',
  alternatePhoneNumber: '',
  email: '',
  preferredContactMethod: '',
  preferredLanguage: '',
  emergencyContactName: '',
  emergencyContactRelationship: '',
  emergencyContactPhone: '',
  addressStreet1: '',
  addressStreet2: '',
  addressCity: '',
  addressPostalCode: '',
  addressCountryId: '',
  addressProvinceId: '',
  instagram: '',
  facebook: '',
  tiktok: '',
  youtube: '',
  leagueRegistrationNumber: '',
  hockeyUsaNumber: '',
  hockeyCanadaNumber: '',
  customMembershipNumber: '',
  loyaltyNumber: '',
}
